export default __webpack_public_path__ + "static/media/moodysLogo.08738ca1.png";